import * as lexDetailActionType from '../actionsType/lexCntDetail.actionType';

// sde19: this reducer is used for content expand details page
export const initialState = {
    status: lexDetailActionType.FETCHING_LEX_DETAIL,
    requestVoucherMsg: null,
    requestedVoucher: null,
    response: null,
    exception: null,
    isBlock: false
};

export function lexCntDetailReducer(state = initialState, action) {
    switch (action.type) {
        case lexDetailActionType.FETCHING_LEX_DETAIL:
            return {...state, status: lexDetailActionType.FETCHING_LEX_DETAIL};
        case lexDetailActionType.FETCHING_LEX_DETAIL_SUCCESS:
            return {...state, response: action.payload, status: lexDetailActionType.FETCHING_LEX_DETAIL_SUCCESS};
        case lexDetailActionType.FETCHING_LEX_DETAIL_ERROR:
            return {...state, status: lexDetailActionType.FETCHING_LEX_ERROR};
        case lexDetailActionType.CLEAR_LEX_DETAIL:
            return {status: lexDetailActionType.FETCHING_LEX_DETAIL, response: null, exception: null};
        case lexDetailActionType.SET_IS_BLOCK:
            return {...state, isBlock: action.payload, status: lexDetailActionType.SET_IS_BLOCK};
        case lexDetailActionType.REQUEST_VOUCHER_ERROR:
            return {...state, requestVoucherMsg: action.payload.msg};
        default:
            return state;
    }
}
